import { SCREEN } from '../actions/screen';

import { maxMobileWidth, maxTabletWidth } from '../helpers/constans';

export const InitialState = {
  screen: null, // desctop, tablet, mobile
};

// REDUCERS
export default function test (state = InitialState, action) {
  switch (action.type) {
    case SCREEN.SET_SCREEN:
      let screen = '';

      if (window.innerWidth <= maxMobileWidth) {
        screen = 'mobile';
      } else if (window.innerWidth <= maxTabletWidth) {
        screen = 'tablet';
      } else {
        screen = 'desktop';
      }

      return Object.assign({}, state, {
        screen: screen,
      });
    default:
      return state
  }
}